var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRetry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4054 7.80238C19.0901 5.5661 16.0163 4.33587 12.7443 4.33587H10.9499L13.8312 1.54735L12.2292 0L6.61368 5.43488L12.1556 10.8752L13.7746 9.3388L10.9102 6.52841H12.75C18.2523 6.52841 22.73 10.8534 22.73 16.1679C22.73 21.4825 18.2523 25.8075 12.75 25.8075C7.24769 25.8075 2.76999 21.4825 2.76999 16.1679V15.0744H0.5V16.1679C0.5 19.3283 1.77368 22.2972 4.08896 24.5335C6.40423 26.7698 9.47805 28 12.75 28C16.0219 28 19.0958 26.7698 21.411 24.5335C23.7263 22.2972 25 19.3283 25 16.1679C25 13.0076 23.7207 10.0387 21.4054 7.80238Z",
    fill: "#454545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetry);
export default __webpack_public_path__ + "static/media/icon-retry.bb768299.svg";
export { ForwardRef as ReactComponent };